import { render, staticRenderFns } from "./ai-answer-button.vue?vue&type=template&id=57262d2d&scoped=true"
import script from "./ai-answer-button.vue?vue&type=script&lang=js"
export * from "./ai-answer-button.vue?vue&type=script&lang=js"
import style0 from "./ai-answer-button.vue?vue&type=style&index=0&id=57262d2d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57262d2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57262d2d')) {
      api.createRecord('57262d2d', component.options)
    } else {
      api.reload('57262d2d', component.options)
    }
    module.hot.accept("./ai-answer-button.vue?vue&type=template&id=57262d2d&scoped=true", function () {
      api.rerender('57262d2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/home/chat/ai-answer-button.vue"
export default component.exports